<script>
//import API from '../api/API'
export default {
  name: "Mixin",
  data() {
    return {
      //userRequest: this.$axios.create({ baseURL: "/api" }), //adele 專用
      userRequest: this.$axios.create({ baseURL: "../api" }), //本機端api & 93線上機
      //userRequest: this.$axios.create({ baseURL: "/Chiayi/API" }), // 舊主機線上路徑
      useNCDR: this.$axios.create({ baseURL: "../ncdr" }),
      // TokenID: null,
      TokenID: null,
      page: "",
      cangetGeft:false,
      isLine:false,
      lineuserid:null,
      GROUPMyList: [],
      apiToken: (data) => this.userRequest.post("/API/Default/Token", data),
      apiACCOUNT_GROUPMy: (data) =>
        this.userRequest.post("/API/Default/ACCOUNT_GROUPMy", data),
    };
  },
  mounted() {
    //console.log("Mixin mounted is called");
    if (sessionStorage.getItem("TokenID") != "") {
      this.TokenID = sessionStorage.getItem("TokenID");
    }
    if (sessionStorage.getItem("isLine") != "" && sessionStorage.getItem("isLine") != null){
      this.isLine = true;
    }
    if (sessionStorage.getItem("lineUserid") != "" && sessionStorage.getItem("lineUserid") != null){
      this.lineuserid = sessionStorage.getItem("lineUserid");
    }
    if (sessionStorage.getItem("getGift") != "" && sessionStorage.getItem("getGift") != null){
      if(sessionStorage.getItem("getGift") == "true"){
        this.cangetGeft = false;
      }else{
        this.cangetGeft = true
      }
    }
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  methods: {
    FunctionToken: function(EXfunction, data_in) {
      this.apiToken({})
        .then((res) => {
          data_in.TokenID = this.TokenID;
          data_in.Token = res.data;
          data_in.Page = this.page;
          EXfunction(data_in);
        })
        .catch((error) => {
          alert("發生錯誤!" + error);
        });
    },
    IsNull(data) {
      if (data == "" || data == null || data == undefined) {
        return "";
      } else {
        return data;
      }
    },
    IsNullEmpty(data) {
      if (data == "" || data == null || data == undefined) {
        return true;
      } else {
        return false;
      }
    },
    async Authority(data) {
      if (this.GROUPMyList.length > 0) {
        if (data.PJ_ID == "") {
          if (this.GROUPMyList.length > 0) {
            if (data.fun) {
              return data.fun(true);
            } else {
              return true;
            }
          } else {
            if (data.fun) {
              return data.fun(false);
            } else {
              return false;
            }
          }
        }

        const asdsad = this.GROUPMyList.filter(
          (word) => word.PJ_ID == data.PJ_ID
        );

        if (asdsad.length > 0) {
          if (data.fun) {
            return data.fun(true);
          } else {
            return true;
          }
        } else {
          if (data.fun) {
            return data.fun(false);
          } else {
            return false;
          }
        }
      } else {
        this.apiACCOUNT_GROUPMy(data)
          .then((res) => {
            const json = JSON.parse(res.data);
            if (json.Status) {
              this.GROUPMyList = JSON.parse(json.Data);
              if (data.PJ_ID == "") {
                if (this.GROUPMyList.length > 0) {
                  if (data.fun) {
                    return data.fun(true);
                  } else {
                    return true;
                  }
                } else {
                  if (data.fun) {
                    return data.fun(false);
                  } else {
                    return false;
                  }
                }
              }

              const asdsad = this.GROUPMyList.filter(
                (word) => word.PJ_ID == data.PJ_ID
              );

              if (asdsad.length > 0) {
                if (data.fun) {
                  return data.fun(true);
                } else {
                  return true;
                }
              } else {
                if (data.fun) {
                  return data.fun(false);
                } else {
                  return false;
                }
              }
            } else {
              console.warn("API錯誤");
            }
          })
          .catch((err) => {
            console.warn(err);
          });
      }
    },
    Authority2(data) {
      if (this.GROUPMyList.length > 0) {
        if (data.PJ_ID == "") {
          if (this.GROUPMyList.length > 0) {
            if (data.fun) {
              return data.fun(true);
            } else {
              return true;
            }
          } else {
            if (data.fun) {
              return data.fun(false);
            } else {
              return false;
            }
          }
        }

        const asdsad = this.GROUPMyList.filter(
          (word) => word.PJ_ID == data.PJ_ID
        );

        if (asdsad.length > 0) {
          if (data.fun) {
            return data.fun(true);
          } else {
            return true;
          }
        } else {
          if (data.fun) {
            return data.fun(false);
          } else {
            return false;
          }
        }
      } else {
        this.apiACCOUNT_GROUPMy(data)
          .then((res) => {
            const json = JSON.parse(res.data);
            if (json.Status) {
              this.GROUPMyList = JSON.parse(json.Data);
              if (data.PJ_ID == "") {
                if (this.GROUPMyList.length > 0) {
                  if (data.fun) {
                    return data.fun(true);
                  } else {
                    return true;
                  }
                } else {
                  if (data.fun) {
                    return data.fun(false);
                  } else {
                    return false;
                  }
                }
              }

              const asdsad = this.GROUPMyList.filter(
                (word) => word.PJ_ID == data.PJ_ID
              );

              if (asdsad.length > 0) {
                if (data.fun) {
                  return data.fun(true);
                } else {
                  return true;
                }
              } else {
                if (data.fun) {
                  return data.fun(false);
                } else {
                  return false;
                }
              }
            } else {
              console.warn("API錯誤");
            }
          })
          .catch((err) => {
            console.warn(err);
          });
      }
    },
    Authority3(data) {
      if (this.GROUPMyList.length > 0) {
        if (data.PJ_ID.length ==0) {
          if (this.GROUPMyList.length > 0) {
            if (data.fun) {
              return data.fun(true);
            } else {
              return true;
            }
          } else {
            if (data.fun) {
              return data.fun(false);
            } else {
              return false;
            }
          }
        }

        const asdsad = this.GROUPMyList.filter(
          (word) => data.PJ_ID.includes(word.PJ_ID)
        );

        if (asdsad.length > 0) {
          if (data.fun) {
            return data.fun(true);
          } else {
            return true;
          }
        } else {
          if (data.fun) {
            return data.fun(false);
          } else {
            return false;
          }
        }
      } else {
        this.apiACCOUNT_GROUPMy(data)
          .then((res) => {
            const json = JSON.parse(res.data);
            if (json.Status) {
              this.GROUPMyList = JSON.parse(json.Data);
              if (data.PJ_ID == "") {
                if (this.GROUPMyList.length > 0) {
                  if (data.fun) {
                    return data.fun(true);
                  } else {
                    return true;
                  }
                } else {
                  if (data.fun) {
                    return data.fun(false);
                  } else {
                    return false;
                  }
                }
              }

              const asdsad = this.GROUPMyList.filter(
                (word) => data.PJ_ID.includes(word.PJ_ID)
              );

              if (asdsad.length > 0) {
                if (data.fun) {
                  return data.fun(true);
                } else {
                  return true;
                }
              } else {
                if (data.fun) {
                  return data.fun(false);
                } else {
                  return false;
                }
              }
            } else {
              console.warn("API錯誤");
            }
          })
          .catch((err) => {
            console.warn(err);
          });
      }
    },
    // throttled(delay, fn) {
    //   let lastCall = 0;
    //   const now = (new Date).getTime();
    //   if (now - lastCall < delay) {
    //     return;
    //   }
    //   lastCall = now;
    //   return fn(...args);
    // },
    // debounced(delay, fn) {
    //   let timerId;
    //     if (timerId) {
    //       clearTimeout(timerId);
    //     }
    //     timerId = setTimeout(() => {
    //       fn(...args);
    //       timerId = null;
    //     }, delay);
    // }
  },
};
</script>
